import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function postAtencionesAltaComentario({ jsonBody }) {
  let url = `${webservice}/postAtencionesAltaComentario`;

  let response = {};

  await superagent
    .post(url)
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .set('Content-Type', 'application/json')
    .send(jsonBody)
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        ...jsonBody,
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
